import * as api from "../../apis/presaleOrder";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {RouteComponentProps, useParams} from "react-router";
import {useHistory} from "react-router-dom";
import {useRequest} from "ahooks";
import {getPresaleOrderDetail} from "../../apis/presaleOrder";
import React, {Fragment, useState} from "react";
import {
    Button,
    Card,
    Col,
    Divider as AntDivider,
    Form,
    Input,
    InputNumber,
    message,
    Modal, Popconfirm,
    Row,
    Space,
    Switch,
    Table
} from "antd";
import styles from "./index.module.css";
import {useForm, useWatch} from "antd/lib/form/Form";
import DatePicker from "../../components/DatePicker";
import Select from "../../components/Select";
import DictSelect from "../../components/DictSelect";
import {ColumnProps} from "antd/lib/table";
import AreaSelect from "../../components/AreaSelect";
import {PlatformType, PresaleOrderStatusEnum, SalesOrderStatusEnum} from "../../utils/constants";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import withAuth from "../../utils/withAuth";
import RemarkModal from "./component/RemarkModal";
import DealerShippingSelectModal from "../../components/DealerShippingSelectModal";
import useAuth from "../../utils/useAuth";


enum OrderPageType {
    presale = 'presale', stockout = "stockout"
}

enum OrderType {
    presale = "preOrder",
    outstock = 'outStockOrder'
}

const OrderTypeMap = {
    preOrder: '预订订单',
    outStockOrder: '缺货订单'
}

type SalesOrderDetailRouteParam = {
    id: string
}

const SubmitButton = withAuth('submit', Button);
const CompleteButton = withAuth('complete', Button);
const RemarkButton = withAuth('remark', Button);
const ClosePopconfirm = withAuth('close', Popconfirm);
const AddressButton = withAuth('address', Button);

function PresaleOrderDetail(props: RouteComponentProps<SalesOrderDetailRouteParam>) {
    const history = useHistory();
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const id = useParams<SalesOrderDetailRouteParam>()?.id;
    const orderPageType = history.location.pathname.indexOf('presale') >= 0 ? OrderPageType.presale : OrderPageType.stockout;
    const orderType = orderPageType === OrderPageType.presale ? OrderType.presale : OrderType.outstock;
    const [order, setOrder] = useState<any>({});
    const [form] = useForm();
    const [remarkModalVisible, setRemarkModalVisible] = useState(false);
    const [dealerShippingModalVisible, setDealerShippingModalVisible] = useState(false);

    const showPrice = useAuth().indexOf('showPrice') > -1 || platform === PlatformType.Admin;

    /**
     * Force Complete Option,
     * force: Sample,
     * restrictForce: Restrict,
     */
    const [forceCompleteOption, setForceCompleteOption] = useState<any>({force: false, restrictForce: false});


    const province = useWatch('province', form);
    const status = useWatch('status', form);
    const products = useWatch('item', form);
    const {loading: loadingClose, run: runClose} = useRequest(api.closeOrder, {
        manual: true,
        onSuccess(res) {
            getOrder(parseInt(id), orderType);
        }
    })
    const {loading: loadingOrder, run: getOrder} = useRequest(api.getPresaleOrderDetail, {
        manual: false,
        defaultParams: [parseInt(id), orderType],
        onSuccess(res) {
            setOrder(res?.data?.data ?? {});
            form.setFieldsValue(res?.data?.data ?? {});
        }
    });

    const {loading: loadingSubmit, run: doSubmit} = useRequest(api.submitPresaleOrder, {
        manual: true,
        onSuccess(res) {
            message.success('订单已提交');
            getOrder(parseInt(id), orderType);
        }
    });

    const {loading: loadingComplete, runAsync: doComplete} = useRequest(api.completePresaleOrder, {
        manual: true,
        onSuccess(res) {
            if (res.data.code == 0) {
                setForceCompleteOption({force: false, restrictForce: false});
                message.success('生成订单成功');
                getOrder(parseInt(id), orderType);
                if (Array.isArray(res.data.data) && res.data.data?.length > 1) {
                    const orderCodes = res.data.data.map((o: any) => o.code).join(', ');
                    Modal.warning({
                        title: '提示',
                        content: `因商品限购数量限制，已自动拆分成多笔订单，新的订单号：${orderCodes}。`
                    });
                }
            }
        }
    });

    const {loading: loadingRemark, run: runRemark} = useRequest(api.editOrder, {
        manual: true,
        onSuccess(res) {
            message.success('修改备注成功');
            setRemarkModalVisible(false);
            getOrder(parseInt(id), orderType);
        }
    });

    const {loading: loadingModify, run: runModify} = useRequest(api.editOrder, {
        manual: true,
        onSuccess(res) {
            message.success('修改成功');
            setDealerShippingModalVisible(false);
            getOrder(parseInt(id), orderType);
        }
    })

    const handleSuitQtyChange = (v: any, index: number) => {
        const curProduct = products[index];
        const suitId = curProduct.suitId;
        [...products || []].filter(p => p.suitId == suitId).forEach((p: any, i) => {
            form.setFieldValue(['item', i, 'currentSuitQty'], v || 0);
            form.setFieldValue(['item', i, 'currentQty'], p.suitQty * (v || 0));
        });
    }

    const handleSubmit = () => {
        doSubmit(parseInt(id));
    }

    const handleComplete = () => {
        const values: any = {orderId: parseInt(id), details: []};
        const productsQty = products.map((p: any) => ({
            detailId: p.id,
            qty: p.currentQty
        })).filter((p: any) => !!p.qty);
        if (!productsQty?.length) {
            message.error('请填写本次下单数量');
            return;
        } else {
            new Promise<boolean>((resolve, reject) => {
                const rebateModal = Modal.confirm({
                    title: '提示',
                    content: '是否使用返利？',
                    okText: '使用',
                    okType: "default",
                    cancelText: '不使用',
                    cancelButtonProps: {type: "primary"},
                    onCancel: () => {
                        rebateModal.destroy();
                        resolve(false);
                    },
                    onOk: () => {
                        rebateModal.destroy();
                        resolve(true);
                    }
                });
            }).then((useRebate) => {
                values.details = productsQty;
                values.rebate = useRebate;
                return values;
            }).then(() => {
                return doComplete(values);
            }).then(res => {
                if (res.data.code !== 0) {
                    let forceKey;
                    if (res.data.code == 1) {
                        forceKey = 'force';
                    } else if (res.data.code == 2) {
                        forceKey = 'restrictForce';
                    } else {
                        return Promise.reject('网络错误');
                    }
                    const tmpForceOption = {...forceCompleteOption, [forceKey]: true};
                    const modal = Modal.confirm({
                        title: '提示',
                        content: res.data.message,
                        okText: '继续下单',
                        cancelText: '取消',
                        onCancel: () => modal.destroy(),
                        onOk: () => {
                            doComplete({...values, ...tmpForceOption});
                            setForceCompleteOption({...tmpForceOption});
                            modal.destroy();
                        }
                    });
                } else {
                    setForceCompleteOption({force: false, restrictForce: false});
                    Promise.resolve(res);
                }
            })
        }
    }

    const finishRemark = (remark: any) => {
        // form.setFieldValue('remark', remark);
        form.validateFields().then((value) => {
            runRemark({...value, remark});
        });
    }

    const productColumns: Array<ColumnProps<any>> = [
        {
            dataIndex: 'lineNumber',
            key: 'lineNumber',
            title: '行号',
            fixed: "left",
            width: 120
        },
        {
            dataIndex: 'suitCode',
            key: 'suitCode',
            title: '套餐编号',
            width: 140
        },
        {
            dataIndex: 'suitName',
            key: 'suitName',
            title: '套餐名称',
            width: 180
        },
        {
            dataIndex: 'productCode',
            key: 'productCode',
            title: '商品编码',
            width: 140
        },
        {
            dataIndex: 'productName',
            key: 'productName',
            title: '商品名称',
            width: 180
        },
        {
            dataIndex: 'specification',
            key: 'specification',
            title: '商品规格',
            width: 160
        },
        {
            dataIndex: 'categoryName',
            key: 'categoryName',
            title: '产品线',
            width: 140,
        },
        {
            dataIndex: 'method',
            key: 'method',
            title: '方法',
            width: 100,
        },
        {
            dataIndex: 'useIn',
            key: 'useIn',
            title: '适用机型',
            width: 100,
        },
        {
            dataIndex: 'unit',
            key: 'unit',
            title: '单位',
            width: 100
        },
        {
            dataIndex: 'qty',
            key: 'qty',
            width: 100,
            title: orderType == OrderType.presale ? '预订数量' : '缺货数量',
            render(v: any, record: any, index) {
                return record.suitId ? `${record.suitProductQty} * ${record.suitQty}` : `${record.qty}`;
            }
        },
        ...showPrice ? [
            {
                dataIndex: 'price',
                key: 'price',
                title: '销售价',
                width: 120,
            }
        ] : [],
        {
            dataIndex: 'completeQty',
            key: 'completeQty',
            width: 140,
            title: '已下单数量',
        },
        {
            dataIndex: 'currentQty',
            key: 'currentQty',
            title: '本次下单数量',
            width: 140,
            fixed: 'right',
            render(v: any, record: any, index) {
                return record.suitId ? (
                    <Form.Item name={[index, 'currentSuitQty']}>
                        <InputNumber style={{width: '100%'}}
                                     disabled={status != PresaleOrderStatusEnum.SUBMITTED && status !== PresaleOrderStatusEnum.PART_COMPLETED}
                                     step={1} min={1}
                                     addonBefore={`${record.suitProductQty} x`}
                                     onChange={v => handleSuitQtyChange(v, index)}/>
                    </Form.Item>
                ) : (
                    <Form.Item name={[index, 'currentQty']}>
                        <InputNumber style={{width: '100%'}}
                                     disabled={status != PresaleOrderStatusEnum.SUBMITTED && status !== PresaleOrderStatusEnum.PART_COMPLETED}
                                     step={1} min={1}/>
                    </Form.Item>
                )
            }
        }
    ];

    const finishAddressSelect = (keys: Array<any>, records: Array<any>) => {
        if (!records.length) {
            return;
        }
        const address = records[0];
        form.setFieldValue('receiverPhone', address.phone);
        form.setFieldValue('receiver', address.name);
        form.setFieldValue('province', address.provinceId);
        form.setFieldValue('city', address.cityId);
        form.setFieldValue('detailAddress', address.address);
        form.validateFields().then(value => runModify(value));
    }


    const toolbar = (
        <div className={styles.Toolbar}>
            <Space>
                合同号：{form.getFieldValue('contractCode')}
            </Space>
            <Space>
                {status == PresaleOrderStatusEnum.NOT_SUBMITTED && platform == PlatformType.Dealer &&
                    <AddressButton type={"link"} loading={loadingModify}
                                   onClick={() => setDealerShippingModalVisible(true)}>修改地址</AddressButton>}
                {status == PresaleOrderStatusEnum.NOT_SUBMITTED && platform == PlatformType.Dealer &&
                    <RemarkButton type={"link"} loading={loadingRemark}
                                  onClick={() => setRemarkModalVisible(true)}>备注</RemarkButton>}
                {status == PresaleOrderStatusEnum.NOT_SUBMITTED && platform == PlatformType.Dealer &&
                    <SubmitButton type={'link'} loading={loadingSubmit} onClick={handleSubmit}>提交</SubmitButton>}
                {(status == PresaleOrderStatusEnum.SUBMITTED || status == PresaleOrderStatusEnum.PART_COMPLETED) && platform == PlatformType.Admin &&
                    <CompleteButton type={'link'} loading={loadingComplete}
                                    onClick={handleComplete}>生成订单</CompleteButton>}
                {platform == PlatformType.Admin &&
                    <ClosePopconfirm title={'是否确认关闭？'} onConfirm={() => runClose(id)}><Button
                        loading={loadingClose} type={'link'}>关闭</Button></ClosePopconfirm>}
                <Button type={'link'} onClick={() => history.goBack()}>返回</Button>
            </Space>
        </div>
    )

    return <PageHeaderLayout>
        <Card title={toolbar}>
            <Form form={form} labelCol={{span: 8}} disabled={true}>
                <Form.Item name={'id'} noStyle/>
                <Form.Item name={'status'} noStyle/>
                <h3 className={styles.SectionTitle}>基本信息</h3>
                <Row>
                    <Col span={8}>
                        <Form.Item name={'code'}
                                   label={orderPageType === OrderPageType.presale ? '预订单号' : '缺货单号'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'orderDate'} label={'订单日期'}>
                            <DatePicker style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'dealerName'} label={'客户'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'hospitalFullName'} label={'终端医院全称'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'expressName'} label={'运输方式'}>
                            {/*<Select url={''} getData={data => data?.data || []} textField={'name'} valueField={'id'}/>*/}
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label={'订单类型'}>
                            <Input value={orderPageType === OrderPageType.presale ? '预定订单' : '缺货订单'}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'expectDeliveryTime'} label={'期望日期'}>
                            <DatePicker style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'salesManName'} label={'销售人员'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'businessManName'} label={'商务人员'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'province'} label={'省'}>
                            <AreaSelect/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'city'} label={'市'}>
                            <AreaSelect type={'city'} parent={province}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'detailAddress'} label={'详细地址'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'receiver'} label={'收货人'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'receiverPhone'} label={'收货人电话'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'paymentForm'} label={'付款形式'}>
                            <DictSelect dict={'PaymentForm'} appendNull={false}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'currency'} label={'币种'}>
                            {/*<Select url={''} getData={data => data?.data || []} textField={'name'} valueField={'id'}/>*/}
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'invoiceType'} label={'发票类型'}>
                            <DictSelect dict={'InvoiceType'} appendNull={false}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'period'} label={'账期'}>
                            <InputNumber addonAfter={'天'} step={1} style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'giveawayInvoiced'} label={'赠品是否开票'} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                    </Col>
                    <Col span={16}>
                        <Form.Item name={'invoiceAddress'} label={'发票详细地址'} labelCol={{span: 4}}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name={'remark'} label={'备注'} labelCol={{span: 2}}>
                            <Input.TextArea rows={3}/>
                        </Form.Item>
                    </Col>
                </Row>
                <div><h3 className={styles.SectionTitle}>商品信息</h3></div>
                <Form.List name={'item'}>
                    {(fields, operation, meta) => (
                        <Table className={styles.ProductTable} columns={productColumns}
                               dataSource={form.getFieldValue('item')} pagination={false} scroll={{x: '100%'}}/>
                    )}
                </Form.List>
            </Form>
            <div className={styles.ProductSummary}>
                <br/>
                <table>
                    <tr style={{fontSize: 'large'}}>
                        <td>订单合计：</td>
                        <td style={{color: 'var(--danger-color)'}}>{form.getFieldValue('productTotalAmount')}</td>
                    </tr>
                </table>
                <br/>
            </div>
        </Card>
        <RemarkModal open={remarkModalVisible} title={'备注'} onCancel={() => setRemarkModalVisible(false)}
                     onComplete={(remark: string) => finishRemark(remark)}/>
        {dealerShippingModalVisible && <DealerShippingSelectModal
            multiple={false}
            open={dealerShippingModalVisible}
            onCancel={() => setDealerShippingModalVisible(false)}
            onComplete={finishAddressSelect}/>}
    </PageHeaderLayout>
}

export default PresaleOrderDetail;
